<template>
  <div>
    <div class="volume">
      <h3>マイクの位置について</h3>
      <img src="@/assets/guides/mic.png" />
    </div>
    <div class="accept-mic">
      <h3>マイク入力の許可について</h3>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h3 {
  margin: 0;
}
.mic-guide {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>